import { render, staticRenderFns } from "./CollegeDashboard.vue?vue&type=template&id=292a15f0"
import script from "./CollegeDashboard.vue?vue&type=script&lang=js"
export * from "./CollegeDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports